import { Pipe, PipeTransform } from '@angular/core';



@Pipe({ name: 'vehicleIndicatorTypeUnit' })
export class VehicleIndicatorTypeUnitPipe implements PipeTransform {

    transform(type: number): any {
        switch (type) {
            case 1:
                return 'l';
            case 2:
                return 'km/h';
            case 3:
                return 'km/h';
            case 4:
                return 'km/h';
            case 5:
                return 'RPM';
            // case 6:
            //     return '^C';
            case 7:
                return 'V';
            case 12:
                return 'Hz';
            case 13:
                return 'Mpa';
            case 15:
                return 'A';
            case 17:
                return 'km';
            case 25:
                return 'V';
            case 27:
                return 'l';
            case 28:
                return 'h';
            default:
                return '';
        }
    }

}